jQuery(document).ready(function($) {

/* ------------------ GET THE COOKIE ------------------ */
    function getCookie(c_name) {
      //console.log('Im getting the cookie information for:' + c_name);
      var c_value = document.cookie;
      var c_start = c_value.indexOf(" " + c_name + "=");
      if (c_start == -1) {
        c_start = c_value.indexOf(c_name + "=");
      }
      if (c_start == -1) {
        c_value = null;
      } else {
        c_start = c_value.indexOf("=", c_start) + 1;
        var c_end = c_value.indexOf(";", c_start);
        if (c_end == -1) {
          c_end = c_value.length;
        }
        c_value = unescape(c_value.substring(c_start, c_end));
      }
      return c_value;
    }

    function setCookie(c_name, value, exdays) {
      //console.log('Im Setting up a cookie!');
      var path = '/';
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
      document.cookie = c_name + "=" + c_value + ";path=" + path + ";";
    }

    // Function after click close button
    function close_pop() {
      $('.m-cta').fadeOut();
      setCookie('signupclose', true, 30); //  days

      setTimeout(function () {
        $('.m-cta').removeClass('js-show');
      }, 1000);

      return false;
    }

    // Function after mail sent successfully
    function mail_sent() {
      // setCookie('signupdone', true, 3650); // Infinito

      $('.m-cta .wpcf7-form .m-cta__content').slideUp();

      // setTimeout(function () {
      //   $('.m-cta').fadeOut();
      //   $('.m-cta').removeClass('js-show');
      // }, 5000);

      return false;
    }

    // Run Function to display the modal
    $(document).ready(function () {
      // displaySignupModal(); // disabled
    });

    // Handles displaying the eye modal form.
    var displaySignupModal = function () {
      if (!getCookie('signupclose') && !getCookie('signupdone')) {
        $('.m-cta').addClass('js-show');
      } else {
        $('.m-cta').removeClass('js-show');
      }
    };

    // Click close button
    $(".m-cta .m-cta__close").click(function () {
      close_pop();
    });


  // Fires when an Ajax form submission has completed successfully, and mail has been sent.
  jQuery(document).ajaxComplete(function() {
    if (jQuery(".m-cta .wpcf7-mail-sent-ok").length) {
      mail_sent();
    }

    if (jQuery(".m-cta .wpcf7-validation-errors").length) {
      // mail_sent(); // for test
    }
  });

  	// lets ensure outgoing links open in new window

    $('.m-page-body a').each(function() {
       var a = new RegExp('/' + window.location.host + '/');
       if (!a.test(this.href)) {
          $(this).attr("target", "_blank");
       }
    });

    $('.o-front-slider__nav-icon').click(function(){
      var Sindex = $('.o-front-slider__nav-icon').index( this );
      $('.o-front-slider__nav-item , .o-front-slider__slide').removeClass('j-active');
      $(this).parent().parent().addClass('j-active');
      $('.o-front-slider__slide').eq(Sindex).addClass('j-active');

    });

// code via Riccardo Giorato https://medium.com/better-programming/a11y-never-remove-the-outlines-ee4efc7a9968
    (function(document, window){
    	var styleText = '::-moz-focus-inner{border:0 !important;}:focus{outline: none !important;';
    	var unfocus_style = document.createElement('STYLE');

    	window.unfocus = function(){
    		document.getElementsByTagName('HEAD')[0].appendChild(unfocus_style);

    		document.addEventListener('mousedown', function(){
    			unfocus_style.innerHTML = styleText+'}';
    		});
    		document.addEventListener('keydown', function(){
    			unfocus_style.innerHTML = '';
    		});
    	};

    	unfocus.style = function(style){
    		styleText += style;
    	};

    	unfocus();
    })(document, window);

}) // End jQuery
